//日本語（Japanese）
export const USER_DEFAULT_LANGUAGE = 1;
export const LANGUAGE_JAPANESE_ID = 1;
export const LANGUAGE_ENGLISH_ID = 2;

// language list
export const LANGUAGE = [
    { "id": 1, "name": "CDMS100OPT001"},
    { "id": 2, "name":  "CDMS100OPT002"},
];

export const LANGUAGE_CODE = {
    JAPANESE: "ja-JP",
    ENGLISH: "en-US"
};

export const LANGUAGE_SHORT_CODE = {
    [LANGUAGE_CODE.JAPANESE]: "jp",
    [LANGUAGE_CODE.ENGLISH]: "en"
};

/**
 * Value in Backend: 
 * EXPORT_LANGUAGE_JAPANESE = 0;
 * EXPORT_LANGUAGE_ENGLISH = 1;
 */
export const EXPORT_LANGUAGE_ID = {
    [LANGUAGE_CODE.JAPANESE]: 0,
    [LANGUAGE_CODE.ENGLISH]: 1
};

